<script setup lang="ts">
import { PhArrowLeft, PhArrowRight } from '@phosphor-icons/vue'

import RouteCodeBadge from '@/components/transit/RouteCodeBadge.vue'
import VehicleRow from '@/components/transit/VehicleRow.vue'
import type { DirectionKey, MapVehicle } from '@/types'
import { directionLabel } from '@/utils/direction'

const props = defineProps<{
  routeCode: string
  routeName?: string
  direction: DirectionKey
  vehicles: MapVehicle[]
}>()

const emit = defineEmits<{ select: [vehicle: MapVehicle] }>()

function selectVehicle(vehicle: MapVehicle) {
  emit('select', vehicle)
}
</script>

<template>
  <section>
    <div class="flex items-center gap-3 border-b bg-muted/40 px-3 py-3">
      <RouteCodeBadge :code="props.routeCode" />
      <span class="min-w-0 flex-1">
        <span class="block text-sm">{{ props.routeName ?? props.routeCode }}</span>
        <span
          class="mt-1 flex items-center gap-1.5 text-xs font-bold"
          :class="props.direction === 'outbound' ? 'text-route-outbound' : 'text-route-inbound'"
        >
          <PhArrowRight v-if="props.direction === 'outbound'" class="size-4" />
          <PhArrowLeft v-else class="size-4" />
          {{ directionLabel(props.direction) }}
        </span>
      </span>
    </div>

    <ul>
      <li v-for="vehicle in props.vehicles" :key="vehicle.id">
        <VehicleRow :vehicle="vehicle" :show-route-meta="false" @click="selectVehicle(vehicle)" />
      </li>
    </ul>
  </section>
</template>
